import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { BaseComponent } from '../BaseComponent';
const CircleMinus = forwardRef(function CircleMinus({ dataTestId, ...props }, ref) {
    const iconRender = useCallbackRef((color) => (_jsx("path", { d: 'M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM3.5 6.25C3.22386 6.25 3 6.47386 3 6.75V7.25C3.0001 7.52606 3.22392 7.75 3.5 7.75H10.5C10.7761 7.75 10.9999 7.52606 11 7.25V6.75C11 6.47386 10.7761 6.25 10.5 6.25H3.5Z', fill: color })));
    return (_jsx(BaseComponent, { ref: ref, viewBox: '0 0 14 14', dataTestId: dataTestId ?? 'circle-minus-icon-svg', iconRender: iconRender, ...props }));
});
export default CircleMinus;
